import { F, T } from "../../theme/tokens";

// ── Filter chips ──────────────────────────────────────────────────────────────

export function FilterChips({ options, active, onChange }: { options: string[]; active: string; onChange: (v: string) => void }) {
  return (
    <div className="chips" style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
      {options.map((o) => (
        <button key={o} onClick={() => onChange(o)}
          style={{ padding: "5px 12px", borderRadius: "9999px", fontSize: "11px", fontFamily: F, fontWeight: 500, cursor: "pointer", border: `1px solid ${o === active ? T.text : T.border}`, background: o === active ? T.text : T.surface, color: o === active ? "#fff" : T.sub, transition: "all 0.15s" }}>
          {o}
        </button>
      ))}
    </div>
  );
}
